export const logger = (...data: any[]) => {
  console.log(`:>`, ...data);
};

export const logError = (data: string, err: any = null) => {
  console.error('=>', data, err);
};
